export default __webpack_public_path__ + "static/media/Paytm.916167ba.png";